import React from 'react';
import { Link } from 'react-router-dom';
import { Construction, Mail, MapPin } from 'lucide-react';
import { merchants, cities } from '../lib/data';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-100">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Construction className="w-6 h-6 text-yellow-400" />
              <span className="font-bold text-white text-lg">HireFy</span>
            </div>
            <p className="text-sm mb-4 text-gray-300">
              Your trusted platform for finding quality equipment hire services across the UK. 
              From tools to machinery, we connect you with reliable local providers.
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-gray-300 hover:text-yellow-400 transition-colors">
                <Mail className="w-4 h-4" />
                <a href="mailto:info@screwhero.com">info@screwhero.com</a>
              </div>
              <div className="flex items-center gap-2 text-gray-300">
                <MapPin className="w-4 h-4" />
                <span>London, UK</span>
              </div>
            </div>
          </div>

          {/* Equipment Categories */}
          <div>
            <h3 className="font-semibold text-white mb-4">Equipment Hire</h3>
            <ul className="space-y-2">
              {merchants.map(merchant => (
                <li key={merchant.slug}>
                  <Link 
                    to={`/${merchant.slug}`}
                    className="text-gray-300 hover:text-yellow-400 transition-colors"
                  >
                    {merchant.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Popular Locations */}
          <div>
            <h3 className="font-semibold text-white mb-4">Popular Locations</h3>
            <div className="grid grid-cols-2 gap-2">
              {cities.slice(0, 8).map(city => (
                <Link 
                  key={city.slug}
                  to={`/tool-hire/${city.slug}`}
                  className="text-gray-300 hover:text-yellow-400 transition-colors"
                >
                  {city.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-white mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/categories" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  All Categories
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-gray-800">
          <p className="text-sm text-gray-400 mb-4 md:mb-0">
            © {new Date().getFullYear()} HireFy. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <Link to="/privacy-policy" className="text-gray-400 hover:text-yellow-400 transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms-of-use" className="text-gray-400 hover:text-yellow-400 transition-colors">
              Terms of Use
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}